import api from "./client";

export async function listInventoryBalances(params = {}) {
  const res = await api.get("/inventory/balances", { params });
  return res.data.data;
}

export async function adjustInventory(payload) {
  const res = await api.post("/inventory/adjust", payload);
  return res.data.data; // { id }
}

export async function importInventory(rows) {
  const res = await api.post("/inventory/import", { rows });
  return res.data.data; // { created, failed, results, failures }
}

